// extracted by mini-css-extract-plugin
export var actionButton = "_j2-t";
export var buttonContainer = "_j2-0";
export var buttonContainer2 = "_j2-1";
export var buttonSection = "_j2-2";
export var details = "_j2-3";
export var dropdownItem = "_j2-5";
export var dropdownItemsContainer = "_j2-4";
export var fileInput = "_j2-r";
export var headerButton = "_j2-6";
export var icon = "_j2-7";
export var input = "_j2-8";
export var macroListItem = "_j2-9";
export var mainContent = "_j2-a";
export var microText = "_j2-b";
export var modal = "_j2-w";
export var optionsButton = "_j2-c";
export var paperclip = "_j2-s";
export var pillContent = "_j2-d";
export var preview = "_j2-e";
export var preview2 = "_j2-f";
export var quillEditor = "_j2-q";
export var selectedMacro = "_j2-g";
export var sidebar = "_j2-h";
export var sidebarHeader = "_j2-j";
export var sidebarList = "_j2-i";
export var sidebarListItem = "_j2-k";
export var sidebarSearch = "_j2-l";
export var snoozeDurationWrapper = "_j2-v";
export var statusPillContainer = "_j2-m";
export var tagsContainer = "_j2-n";
export var unselectedMacro = "_j2-o";
export var variable = "_j2-u";
export var wrapper = "_j2-p";